'use client';
import cn from 'classnames';
import NextLink from 'next/link';
import Image from 'next/image';
import { BuilderImageProps } from '@/types/Builder';

import './StaticHero.style.scss';

type StaticHeroProps = {
  className?: string;
  priority?: boolean;
  image: {
    desktop: BuilderImageProps;
    mobile: BuilderImageProps;
  };
  linkUrl?: string;
};

function StaticHero(props: StaticHeroProps) {
  const { className = '', image, priority = false, linkUrl } = props;
  const { desktop, mobile } = image;

  const imageContent = (
    <>
      <div
        className='StaticHero-container StaticHero-container-mobile'
        style={{
          paddingBottom: `${(mobile.imageHeight / mobile.imageWidth) * 100}%`
        }}
      >
        <Image
          className='StaticHero-image StaticHero-image-mobile'
          src={mobile.image}
          alt={mobile.imageAltText}
          height={mobile.imageHeight}
          width={mobile.imageWidth}
          priority={priority}
        />
      </div>
      <div
        className='StaticHero-container StaticHero-container-desktop'
        style={{
          paddingBottom: `${(desktop.imageHeight / desktop.imageWidth) * 100}%`
        }}
      >
        <Image
          className='StaticHero-image StaticHero-image-desktop'
          src={desktop.image}
          alt={desktop.imageAltText}
          height={desktop.imageHeight}
          width={desktop.imageWidth}
          priority={priority}
        />
      </div>
    </>
  );

  return (
    <div className={cn('StaticHero', className)}>
      {linkUrl ? (
        <NextLink href={linkUrl}>{imageContent}</NextLink>
      ) : (
        imageContent
      )}
    </div>
  );
}

export default StaticHero;
